import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserPermissionsService } from '../../services/user-permissions.service';
@Directive({
  selector: '[userHasPermission]'
})
export class HasPermissionDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userPermissionsService: UserPermissionsService
  ) {}

  @Input() set userHasPermission(permission: string) {
    // console.log("directive_permission = ", permission);
    if (this.userPermissionsService.hasComponentPermission(permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
